import React, { FC } from 'react';
import ComparePlansCardDetailStyled from './ComparePlansCardDetailStyled';
import { H4 } from '~/components/Typography';
import ButtonStyled from '~/components/Button/ButtonStyled';
import InfoCircle from '../../Icons/outline/InfoCircle';
import Tooltip from '~/components/Tooltip';
import { Plan } from '~/types/plan';
import useWindowSize from '~/hooks/useWindowSize';

interface Props {
  planDetail: Plan;
  tooltipContent?: string;
  onSelectProduct?: (productId: string) => void;
}

const ComparePlansCardDetail: FC<Props> = ({ planDetail, tooltipContent, onSelectProduct }) => {
  const { xsMobile, mobile } = useWindowSize();
  const badge = planDetail?.isBestValue || planDetail?.isFastest;
  const fastest = planDetail?.isFastest;
  const isSmallScreen = xsMobile || mobile;
  return (
    <ComparePlansCardDetailStyled badge={badge} fastest={fastest} selected={!!planDetail}>
      {planDetail && (
        <>
          {badge && (
            <div className={fastest ? 'plan-badge fast-badge' : 'plan-badge best-badge'}>
              <span>{fastest ? 'Our Fastest Plan' : 'Best Value'}</span>
            </div>
          )}
          <div className="plan-name">
            <H4>{planDetail.name}</H4>
          </div>
          <div className="plan-details">
            <div className="plan-price">
              <H4>${planDetail.price}</H4>
              {tooltipContent && (
                <Tooltip tabIndex={0} theme="light" interactive={true} html={<span>{tooltipContent}</span>}>
                  <InfoCircle />
                </Tooltip>
              )}
            </div>
            <span>{planDetail.duration}</span>
          </div>
          <div className="btn-select-plan-compare">
            <ButtonStyled
              onClick={() => {
                onSelectProduct && onSelectProduct(planDetail.productId);
              }}
            >
              {!isSmallScreen ? 'SELECT' : 'Select'}
            </ButtonStyled>
          </div>
        </>
      )}
    </ComparePlansCardDetailStyled>
  );
};

export default ComparePlansCardDetail;
ComparePlansCardDetail.displayName = 'ComparePlansCardDetail';
